import { useEffect, useState } from "react";
import { Button, Tabs, Tab, Box } from "@mui/material";

import PreScreenQuestionBuilder from "./PreScreenQuestionBuilder";
import VideoQuestionBuilder from "./VideoQuestionBuilderTab";
import { useDispatch } from "react-redux";
import { AddPreScreenTemplateAction } from "../../../../../../store/ATS/FormTemplate/Action";

const EditScreeningQuestionsDialog = ({
  onClose,
  jobPostData,
  setPostJobData,
  prescreenTemplate,
  handlepreScreenTemplateLoading,
  errors,
  rolesresponsibilities,
  description,
  prebuilderTitle,
  setPreBuilderTitle,
}) => {
  const dispatch = useDispatch();
  const [tab, setTab] = useState(0);
  const [jobEditData, setJobEditData] = useState({
    prescreen_template_id: "",
    prescreen_random_freq: {
      prequestion_random_freq: "",
      video_random_freq: ""
    }
  });
  const [preScreenQuestions, setPreScreenQuestions] = useState([]);
  const [videoQuestions, setVideoQuestions] = useState([]);
  useEffect(() => {
    setPreScreenQuestions(jobPostData?.prescreen_template_json || []);
    setVideoQuestions(jobPostData?.video_prescreen_template_json || []);
    setJobEditData({
        prescreen_template_id: jobPostData?.prescreen_template_id || "",
        prescreen_random_freq: {
          prequestion_random_freq: jobPostData?.prescreen_random_freq?.prequestion_random_freq || "",
          video_random_freq: jobPostData?.prescreen_random_freq?.video_random_freq || ""
        }
    });
    // eslint-disable-next-line
  }, []);

  const handleSave = () => {
    setPostJobData((prev) => ({
      ...prev,
      prescreen_template_json: preScreenQuestions,
      video_prescreen_template_json: videoQuestions,
      prescreen_template_id: jobEditData?.prescreen_template_id,
      prescreen_random_freq: {...jobEditData?.prescreen_random_freq}
    }));

    onClose();
  };
  const handleSaveNewPreScreenTemplate = () => {
    dispatch(
      AddPreScreenTemplateAction(
        {
          prescreen_template_name: prebuilderTitle,
          prescreen_template_fields: JSON.stringify(preScreenQuestions),
        },
        (error, response) => {
          if (!error && response?.data?.statuscode === 200) {
            const resData = response?.data?.data?.length
              ? response?.data?.data
              : [];
            setPostJobData((prev) => {
              return {
                ...prev,
                prescreen_template_id: resData[resData?.length - 1],
              };
            });
            setPreBuilderTitle("");
            handlepreScreenTemplateLoading("new", resData);
          }
        },
      ),
    );
  };
  const handleChange = (event, value) => {
    if (["prescreen_template_id"].includes(event)) {
      if (value) {
        if (value?.id === null) {
          setPreBuilderTitle(value?.prescreen_template_name);
          setJobEditData({prescreen_template_id: ""})
        } else {
          setJobEditData({ [event]: value });
          setPreScreenQuestions(
            value?.prescreen_template_fields || [],
          );
          setVideoQuestions([])
          setPreBuilderTitle("");
        }
      }
    }
  }

  return (
    <Box mt={-2}>
      <Box>
        <Tabs
          value={tab}
          onChange={(e, val) => setTab(val)}
          sx={{
            minHeight: 32,
            height: 32,
            mb: 1,
            "& .MuiTab-root": {
              minHeight: 32,
              height: 32,
              padding: "0 12px",
              textTransform: "none",
              fontWeight: 600,
              fontSize: "0.85rem",
            },
          }}
        >
          <Tab label="Pre-Screen Questions" />
          <Tab label="Video Questions" />
        </Tabs>
        
        <Box>
          {tab === 0 && (
            <PreScreenQuestionBuilder
              questions={preScreenQuestions}
              setQuestions={setPreScreenQuestions}
              jobPostData={{...jobPostData, ...jobEditData}}
              setPostJobData={setJobEditData}
              handlepreScreenTemplateLoading={handlepreScreenTemplateLoading}
              prescreenTemplate={prescreenTemplate}
              handleChange={handleChange}
              errors={errors}
              rolesresponsibilities={rolesresponsibilities}
              description={description}
              prebuilderTitle={prebuilderTitle}
              setPreBuilderTitle={setPreBuilderTitle}
              handleSaveNewPreScreenTemplate={handleSaveNewPreScreenTemplate}
            />
          )}

          {tab === 1 && (
            <VideoQuestionBuilder
              videoQuestions={videoQuestions}
              setVideoQuestions={setVideoQuestions}
              jobPostData={{...jobPostData, ...jobEditData}}
              setPostJobData={setJobEditData}
              rolesresponsibilities={rolesresponsibilities}
              description={description}
            />
          )}
        </Box>
      </Box>

      <Box sx={{ mt: 2, display: 'flex', justifyContent: "flex-end", gap: 2 }}>
        <Button variant="outlined" onClick={onClose}>Cancel</Button>
        <Button
          variant="contained"
          onClick={handleSave}
          className="mpl-primary-btn"
        >
          Apply
        </Button>
      </Box>
    </Box>
  );
};

export default EditScreeningQuestionsDialog;
